import React, { Fragment, useEffect, useState } from 'react'
import { useTranslate, useNotify, useRedirect, } from 'react-admin'
import { CircularProgress, Button, TextField, Grid, Typography, Icon, FormHelperText, FormControl, MenuItem, Select } from '@mui/material'
import { billingFormServices } from 'src/services/payment/billingForm/billingForm.service';


function BillingFormConciliationCreate() {
	const notify = useNotify()
	const translate = useTranslate()
	const redirect = useRedirect();

	// Upload Files
	const [selectedFileBank, setSelectedFileBank] = useState(null);
	const [selectedBank, setSelectedBank] = useState("0");
	const [fileNameBank, setFileNameBank] = useState("");
	const [errorWithFile, setErrorWithFile] = useState(false);
	const [errorFileBankMessage, setErrorWithFileMessage] = useState("");
	const [errorWithSelectBank, setErrorWithSelectBank] = useState(false);
	const [sendRequest, setSendRequest] = useState(false);


	// Filters
	const [filterInputs, setFilterInputs] = useState({
		status: '',
		bussinesUnit: '',
		workUnit: '',
		user: '',
		reservation: '',
		createdAfter: '',
		createdBefore: '',
	})

	const handleSendConciliation = async () => {
		// Verificar que se haya cargado un archivo y seleccionado un banco
		if (!selectedFileBank) {
			setErrorWithFile(true);
			setErrorWithFileMessage("Campo requerido.");
			return;
		} else {
			setErrorWithFile(false);
			setErrorWithFileMessage("");
		}
		if (selectedBank === "0") {
			setErrorWithSelectBank(true);
			return;
		} else {
			setErrorWithSelectBank(false);
		}

		if (!errorWithFile && !errorWithSelectBank) {
			setSendRequest(true);
			const formData = new FormData();
			formData.append("bank_name", selectedBank); // Agregar el nombre del banco como string
			formData.append("extract_file", selectedFileBank); // Agregar el archivo

			try {
				const response = await billingFormServices.uploadConciliation(formData);
				console.log('%c handleSendConciliation / response : ', 'color: #fff3e6; background: #ff8500', response);
				notify(`Carga de conciliación exitosa`, { type: 'success' });
				setSendRequest(false);
			} catch (error) {
				console.log('%c handleSendConciliation /  error: ', 'color: #fff3e6; background: #ff8500', error);
				notify(error.response.data.detail, { type: 'error' })
				setSendRequest(false);
			}
		}
	};

	const handleUploadClick = (event, bank) => {
		const file = event.target.files[0];

		const allowedExtensions = /(\.xlsx)$/i;
		const isExcelFile = allowedExtensions.test(file.name);

		if (isExcelFile) {
			if (file && bank === "bank") {
				setSelectedFileBank(file);
				setFileNameBank(file.name);
				setErrorWithFile(false);
				setErrorWithFileMessage("");
			}
		} else {
			setErrorWithFile(true);
			setSelectedFileBank(null);
			setFileNameBank("");
			setErrorWithFileMessage(translate('ra.message.upload_only_xlsx_files'));
		}
	};

	return (
		<div className='conciliationExtractContainer'>
			<div className='message'><Typography variant="body2" color="textSecondary" component="span">
				{translate('ra.message.upload_documents_create_reconciliation')}
			</Typography></div>
			<div className='container'>
				<Grid container spacing={3}>
					<Grid item md={5} >
						<div className="componentUploadFileInput" >
							<div className="divButton">
								<input
									className="input"
									accept=".xlsx"
									id="ButtonProductUpFileBank"
									type="file"
									onChange={event => handleUploadClick(event, "bank")}
								/>
								<label htmlFor="ButtonProductUpFileBank" className="button">
									<Button variant="outlined" color="primary" component="span">
										<Icon>post_add</Icon>
									</Button>
								</label>
							</div>
							<div className="bloqFileName">
								<div className="inputlabel">{translate('ra.field.extract_file')}:</div>
								<TextField
									size='small'
									fullWidth
									value={fileNameBank || ''}
									disabled={true}
									placeholder={translate('ra.message.select_file')}
									className="inputcomponent"

								/>
								{errorWithFile && <FormHelperText error>{errorFileBankMessage}</FormHelperText>}
							</div>

						</div>
					</Grid>
					<Grid item md={5} >
						<div className="inputlabel">Banco:</div>
						<FormControl fullWidth variant='outlined' size='small' className='generalComponentSelect' error={errorWithSelectBank}>
							<Select
								id="selectBank"
								value={selectedBank}
								onChange={(e) => setSelectedBank(e.target.value)}
								variant="outlined"
								size="small"
							>
								<MenuItem key={1} value="0">
									<em className="selectOptionDisabled">{translate('ra.action.select_with_dots')}</em>
								</MenuItem>
								<MenuItem key={2} value={'PATARS'}>Banco Patagonia</MenuItem>
								<MenuItem key={3} value={'RIOARS'}>Banco Santander (pesos)</MenuItem>
								<MenuItem key={4} value={'RIOUSD'}>Banco Santander (dólares)</MenuItem>
								<MenuItem key={5} value={'BASEUSD'}>Banco Base (dólares)</MenuItem>
								<MenuItem key={6} value={'BASEMXN'}>Banco Base (pesos mexicanos)</MenuItem>
								<MenuItem key={7} value={'MACUSD'}>Banco Macro (dólares)</MenuItem>
							</Select>
							{errorWithSelectBank && <FormHelperText className='componenteHelperText' error>{translate('ra.validation.required')}</FormHelperText>}
						</FormControl>
					</Grid>
					<Grid className="sendButton" item md={1} >
						<Button disabled={sendRequest} fullwidth onClick={() => handleSendConciliation()} startIcon={sendRequest ? <CircularProgress size={20} color="primary" /> : <Icon>send</Icon>}
							variant="contained" color="primary" >{translate('ra.action.send')}</Button>
					</Grid>
				</Grid>
			</div>
		</div>
	)
}

export default BillingFormConciliationCreate